export default __webpack_public_path__ + "static/media/mpn-logotype-d.1a676fbd.svg";